module.exports = __webpack_public_path__ + "img/home-hack-store.a9133293.svg";